import { render, staticRenderFns } from "./RuleBulkEdit.vue?vue&type=template&id=6c5cb762&scoped=true"
import script from "./RuleBulkEdit.vue?vue&type=script&lang=js"
export * from "./RuleBulkEdit.vue?vue&type=script&lang=js"
import style0 from "./RuleBulkEdit.vue?vue&type=style&index=0&id=6c5cb762&prod&lang=css"
import style1 from "./RuleBulkEdit.vue?vue&type=style&index=1&id=6c5cb762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5cb762",
  null
  
)

export default component.exports